<template>
  <div class="grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-8 gap-3">
    <KpiTile label="Visitors" :metric="k.visitors" :loading="loading" :dot-color="PALETTE.blue"
      definition="Distinct people who reached one of your public pages in this period. Counted by browser, so the same person on a phone and a laptop is two." />
    <KpiTile label="New" :metric="k.new_visitors" :loading="loading" :dot-color="PALETTE.green"
      definition="Visitors with no earlier visit on record before this period opened." />
    <KpiTile label="Returning" :metric="k.returning_visitors" :loading="loading" :dot-color="PALETTE.violet"
      definition="Visitors we had already seen before this period opened. New and returning are measured over the same population, so together they always equal Visitors." />
    <KpiTile label="Booked" :metric="k.booked" :loading="loading" :dot-color="PALETTE.cyan"
      definition="Visitors who completed a booking during this period." />
    <KpiTile label="Conversion" :metric="k.conversion_rate" format="percent" :loading="loading" :dot-color="PALETTE.cyan"
      definition="Share of visitors who ended up booking." />
    <KpiTile label="Found no slots" :metric="k.dead_end_rate" format="percent" :loading="loading"
      :dot-color="PALETTE.amber" :higher-is-better="false"
      definition="Of the people who opened one of your calendars, the share who were shown nothing bookable. The most directly fixable number on this page." />
    <KpiTile label="Form rejections" :metric="k.form_failure_rate" format="percent" :loading="loading"
      :dot-color="PALETTE.red" :higher-is-better="false"
      definition="Of the people who submitted a booking form, the share the server turned away. A number that should be near zero." />
    <KpiTile label="Page views" :metric="k.page_views" :loading="loading" :dot-color="PALETTE.slate"
      definition="Total profile and event page views, repeat views by the same person included." />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import KpiTile from '../shared/KpiTile.vue'
import { PALETTE } from '../shared/useAnalyticsChart.js'

const props = defineProps({
  kpis:    { type: Object, default: null },
  loading: { type: Boolean, default: false },
})

const k = computed(() => props.kpis || {})
</script>
